import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import WikipediaModal from '../../home/components/wikipediaModal';
import ChecklistModal from '../../home/components/checklistModal';
import EventsApi from '../../../api/eventsApi/eventsApi';
import { fetchWikipediaData } from '../../../api/publicApi/wikipedia';

interface WikipediaData {
    title: string | null;
    summary: string | null;
    thumbnail: string | null;
}

const ReportPages = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [pinData, setPinData] = useState<any>(null);
    const [wikipediaData, setWikipediaData] = useState<WikipediaData>({
        title: null,
        summary: null,
        thumbnail: null
    });
    const [checklistOpen, setChecklistOpen] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (!id) return;

            try {
                setLoading(true);
                // Pin bilgilerini al
                const response = await EventsApi.getPins();
                const pin = Array.isArray(response) ? response.find(p => p.id === id) : null;
                
                if (pin) {
                    // Pin'i radius bilgisiyle birlikte ayarla
                    const pinWithRadius = {
                        ...pin,
                        radius: pin.radiusInMeters
                    };
                    setPinData(pinWithRadius);

                    // Wikipedia verilerini al
                    const pinInfo = await EventsApi.getPinInfo(id);
                    if (pinInfo.Name) {
                        const wikiData = await fetchWikipediaData(pinInfo.Name);
                        setWikipediaData({
                            title: pinInfo.Name,
                            summary: wikiData?.extract || pinInfo.QuestionsJson?.wikipediaSummary || null,
                            thumbnail: wikiData?.thumbnail?.source || null
                        });
                    }
                }
            } catch (error) {
                console.error('Veri yüklenirken hata:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [id]);

    const handleOpenChecklist = () => {
        setChecklistOpen(true);
    };

    const handleCloseChecklist = () => {
        setChecklistOpen(false);
    };

    return (
        <>
            <WikipediaModal
                open={!checklistOpen}
                onClose={() => {}}
                onDelete={() => {}}
                onCreateReport={() => {}}
                onOpenChecklist={handleOpenChecklist}
                title={wikipediaData.title}
                loading={loading}
                summary={wikipediaData.summary}
                savedPinData={pinData}
            />
            
            {id && (
                <ChecklistModal
                    open={checklistOpen}
                    onClose={handleCloseChecklist}
                    pinId={id}
                />
            )}
        </>
    );
};

export default ReportPages;
